import { Box, Grid, Typography, useTheme } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { Markdown } from "~/components/markdown";
import {
  MSI_CMD_COMMAND,
  MSI_POWERSHELL_COMMAND,
  SCAN_COMMAND,
  buildConfigureServiceCommand,
} from "../utils";

interface MsiInstallationStepsProps {
  tokenValue: string;
}

export const MsiInstallationSteps = ({
  tokenValue,
}: MsiInstallationStepsProps) => {
  const theme = useTheme();
  const configureServiceCommand = buildConfigureServiceCommand(tokenValue);

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Command
          number={2}
          options={{
            fontSize: { xs: 16 },
            dotColor: theme.palette.background.lightest,
          }}
        >
          Execute MSI installer as administrator
        </Command>
      </Box>
      <Box sx={{ pl: 6, mb: 5 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          The MSI can be executed via PowerShell:
        </Typography>
        <Markdown
          source={`\`\`\`powershell\n${MSI_POWERSHELL_COMMAND}\n\`\`\``}
        />

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 1, mt: 2 }}
        >
          Or via cmd:
        </Typography>
        <Markdown source={`\`\`\`cmd\n${MSI_CMD_COMMAND}\n\`\`\``} />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Command
          number={3}
          options={{
            fontSize: { xs: 16 },
            dotColor: theme.palette.background.lightest,
          }}
        >
          Configure cnspec to run as a service using PowerShell
        </Command>
      </Box>
      <Box sx={{ pl: 6, mb: 5 }}>
        <Markdown
          source={`\`\`\`powershell\n${configureServiceCommand}\n\`\`\``}
        />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Command
          number={4}
          options={{
            fontSize: { xs: 16 },
            dotColor: theme.palette.background.lightest,
          }}
        >
          Use cnspec to scan your Windows host
        </Command>
      </Box>
      <Box sx={{ pl: 6 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Markdown source={`\`\`\`bash\n${SCAN_COMMAND}\n\`\`\``} />
        </Grid>
      </Box>
    </>
  );
};
